import { Color, Icon, Text } from '@billy/design-system'
import { ReactNode } from 'react'

import * as Styled from './styles'

/* Add more if needed, like warning */
type InfoSectionVariant = 'information'

interface InfoSectionProps {
  infoText: string | ReactNode
  variant?: InfoSectionVariant
}

const getVariantStyles = (variant: InfoSectionVariant) => {
  switch (variant) {
    case 'information':
      return {
        color: Color.Purple800,
        backgroundColor: Color.Purple200,
        icon: 'info' as const,
      }
    default:
      return {
        color: Color.Purple800,
        backgroundColor: Color.Purple200,
        icon: 'info' as const,
      }
  }
}

export const InfoSection = ({ infoText, variant = 'information' }: InfoSectionProps) => {
  const { color, backgroundColor, icon } = getVariantStyles(variant)

  return (
    <Styled.InfoSectionWrapper backgroundColor={backgroundColor}>
      <Icon icon={icon} color={color} />
      <Text weight="bold" color={color} variant="bodySM">
        {infoText}
      </Text>
    </Styled.InfoSectionWrapper>
  )
}
